<template>
  <div id="app">
    <noscript v-if="googleNoScript()">
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WMHLF6V"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    </noscript>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  methods: {
    googleNoScript: function () {
      if (window.location.href.indexOf('administrator') > -1) {
        return false
      }
      return true
    }
  }
}
</script>
